export const JWT_DOMAIN = '.withpower.com'
export const JWT_VERSION = 2

export function getJwtCookieName() {
  return `jwt_v${JWT_VERSION}`
}
